import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=b7fbe2ac&"
import script from "./Formulario.vue?vue&type=script&lang=ts&"
export * from "./Formulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b7fbe2ac', component.options)
    } else {
      api.reload('b7fbe2ac', component.options)
    }
    module.hot.accept("./Formulario.vue?vue&type=template&id=b7fbe2ac&", function () {
      api.rerender('b7fbe2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/ContratosSiga/Formulario.vue"
export default component.exports